import React from "react";
import { cn } from "@/lib/utils";

export function StatCard({ label, value, icon: Icon, accent = "text-blue-600", sub, testid }) {
  return (
    <div data-testid={testid} className="bg-white border border-slate-200 rounded-xl p-5 flex flex-col gap-3 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-[transform,box-shadow] duration-200">
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-[0.12em] font-bold text-slate-500">{label}</span>
        {Icon && <Icon className={cn("w-5 h-5", accent)} />}
      </div>
      <div className="font-head text-3xl font-semibold text-slate-900">{value}</div>
      {sub && <div className="text-xs text-slate-500">{sub}</div>}
    </div>
  );
}
